import type { ReactNode } from "react";

export function LoadingState({
  label,
  title = label,
  description,
  icon,
  className = "",
}: {
  label: string;
  title?: ReactNode;
  description?: ReactNode;
  icon?: ReactNode;
  className?: string;
}) {
  return (
    <div
      aria-busy="true"
      aria-live="polite"
      aria-label={label}
      role="status"
      className={`flex min-h-80 flex-col items-center justify-center rounded-[28px] bg-surface px-6 py-12 text-center ${className}`}
      data-loading-state
    >
      <div aria-hidden="true" className="relative mb-7 grid h-20 w-20 place-items-center rounded-[28px] bg-primary/[0.06] text-primary">
        <span className="absolute inset-2 rounded-full border-2 border-primary/10 border-t-primary/70 animate-[spin_2s_linear_infinite] motion-reduce:animate-none" />
        {icon ?? (
          <span className="flex items-end gap-1">
            <span className="h-3 w-1.5 rounded-full bg-primary/40" />
            <span className="h-5 w-1.5 rounded-full bg-primary/70" />
            <span className="h-4 w-1.5 rounded-full bg-primary" />
          </span>
        )}
      </div>
      <p className="max-w-md text-balance text-xl font-semibold tracking-tight text-text sm:text-2xl">{title}</p>
      {description ? <p className="mt-3 max-w-sm text-pretty text-sm leading-6 text-text-secondary">{description}</p> : null}
    </div>
  );
}
